module.exports = __webpack_public_path__ + "img/growth.f9f148ff.png";